import { ConfigurationModel, ConfigurationMainModel, ConfigurationKeys } from 'franke-trough-dependencies';

export const getConfigurationItems = (configuration: ConfigurationModel): ConfigurationMainModel => {
  const configurationMain: ConfigurationMainModel | {} = {};
  Object.keys(ConfigurationKeys).forEach(key => 
    configurationMain[ConfigurationKeys[key]] = configuration[ConfigurationKeys[key]]
  );
  return configurationMain as ConfigurationMainModel;
};
